import React from "react";
import {
  Card,
  Skeleton,
  Typography,
} from "antd";
import { useMediaQuery } from "@mui/material";

const ProductCardSkeleton = ({ index, partialData }) => {
  const isDesktop = useMediaQuery("(min-width:768px)"); // same breakpoint as before


  return (
    <Card
      hoverable
      className={!isDesktop? "product-card-skeleton-mobile" : "product-card-skeleton"}
      style={{
        width: "100%",
        height: "100%",
        marginRight:"12px",
        display: "flex",
        flexDirection: "column",
      }}
          bodyStyle={{
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
      cover={
        <div
        className="skeletonImage"
          style={{
            width: "100%",
            height: "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",

          }}
        >
          {partialData?.[index]?.["image"] ? (
            <img
              alt="product"
              src={partialData[index]["image"]}
              style={{
                maxWidth: "90%",
                maxHeight:!isDesktop ? "80%":"100%",
                objectFit: "contain",
              }}
            />
          ) : (
            <Skeleton.Image
              active
              style={{
                width: "100%",
                height: "90px",
              }}
            />
          )}
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          flex: 1,
        }}
      >
        {/* Title Section */}
        <div style={{ minHeight: "48px" }}>
          {partialData?.[index]?.["title"] ? (
            <Typography.Text
              strong
              style={{
                fontSize: "12px",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                lineHeight: "1.5",
                height: "3em", // 2 lines * 1.5 line-height
              }}
            >
              {partialData[index]["title"]}
            </Typography.Text>
          ) : (
            <Skeleton
              active
              paragraph={{ rows: 2, width: "100%" }}
              title={false}
            />
          )}
        </div>

        {/* Additional skeleton sections */}
        <div>
          <Skeleton
            active
            paragraph={{ rows: 1, width: "60%" }}
            title={false}
          />
        </div>

        <div>
          <Skeleton
            active
            paragraph={{ rows: 1, width: "40%" }}
            title={false}
          />
        </div>
      </div>
    </Card>
  );
};

export default ProductCardSkeleton;